// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"11d6b330","453":"a389b186","876":"5b8bafba"}[chunkId] + ".chunk.js";
};